import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: {
	maxLabel: MessageDescriptor;
	headline: MessageDescriptor;
	body: MessageDescriptor;
	ctaButton: MessageDescriptor;
	dismissButton: MessageDescriptor;
	primaryTaskTitle: MessageDescriptor;
	primaryTaskMeta: MessageDescriptor;
	primaryTaskMetaTimestamp: MessageDescriptor;
	secondaryTaskTitle: MessageDescriptor;
	secondaryTaskMeta: MessageDescriptor;
} = defineMessages({
	maxLabel: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.max-label',
		defaultMessage: 'Max',
		description: 'Label for Max in the full-page Max introductory banner.',
	},
	headline: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.headline',
		defaultMessage: 'Meet Max. It handles everything.',
		description: 'Headline for the full-page Max introductory banner.',
	},
	body: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.body',
		defaultMessage: 'Max takes on complex, multi-step work and comes back with a finished result.',
		description: 'Body text for the full-page Max introductory banner.',
	},
	ctaButton: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.cta-button',
		defaultMessage: 'Get a team summary',
		description: 'Primary CTA button label for the full-page Max introductory banner.',
	},
	dismissButton: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Accessible label for dismissing the full-page Max introductory banner.',
	},
	primaryTaskTitle: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title',
		defaultMessage: 'Implement new authentication system',
		description: 'Decorative task card title shown in the full-page Max banner artwork.',
	},
	primaryTaskMeta: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta',
		defaultMessage: 'Awaiting user response',
		description: 'Decorative task card status text shown in the full-page Max banner artwork.',
	},
	primaryTaskMetaTimestamp: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp',
		defaultMessage: '1 minute ago',
		description: 'Decorative task card timestamp text shown in the full-page Max banner artwork.',
	},
	secondaryTaskTitle: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title',
		defaultMessage: 'New Policy Presentation',
		description: 'Decorative task card title shown in the full-page Max banner artwork.',
	},
	secondaryTaskMeta: {
		id: 'post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta',
		defaultMessage: 'Just now',
		description: 'Decorative task card metadata shown in the full-page Max banner artwork.',
	},
});

export default messages;
